export const NavbarStrings = {
  pageName: "Pozivnica.hr",
  testimonials: "Recenzije",
  createRsvp: "Kreiraj pozivnicu",
  login: "Prijavi se",
  myRsvps: "Moje pozivnice",
  logout: "Odjavi se",
};

export const HeroStrings = {
  header: "Bolji način slanja pozivnica!",
  paragraph:
    "Od uzbuđenja vjenčanja do radosti rođendana, naša platforma osigurava da vaše pozivnice odražavaju važnost vašeg događaja s elegancijom i lakoćom.",
  createRsvpButton: "Kreiraj pozivnicu",
  loginButton: "Prijavi se",
  myRsvps: "Moje pozivnice",
};

export const FeaturesStrings = {
  header: "Rješavamo Vaše brige s pozivnicama i rasporedom sjedenja",
  designFeatName: "Dizajniraj pozivnicu",
  designFeatText:
    "Izradite i prilagodite digitalne pozivnice prema Vašim željama i potrebama, uz brojne opcije za personalizaciju.",
  sendFeatName: "Pošaljite pozivnice i pratite odgovore",
  sendFeatText:
    "Jednostavno distribuirajte svoje pozivnice i pratite odgovore gostiju, omogućujući Vam precizno planiranje vašeg događaja.",
  guestListFeatName: "Upravljajte popisom gostiju",
  guestListFeatText:
    "Održavajte uredan i ažuriran popis gostiju, s mogućnošću pregleda, uređivanja i organiziranja svih važnih informacija.",
  guestTableFeatName: "Rasporedite stolove",
  guestTableFeatText:
    "Efikasno planirajte raspored sjedenja kako bi osigurali da svi Vaši gosti budu smješteni na odgovarajući način.",
  featParagraph:
    "Zaboravite stres oko izrade pozivnica i organizacije sjedenja! Na Pozivnica.hr omogućavamo vam da brzo i jednostavno kreirate personalizirane pozivnice te efikasno upravljate popisom gostiju i rasporedom stolova.",
  featParagraph2:
    "Sve što trebate učiniti je opustiti se i uživati u svom posebnom danu, dok mi brinemo o ostalom!",
};

export const TestimonialStrings = {
  header: "Recenzije",
};

export const FooterStrings = {
  header: "Pozivnica.hr",
  copyright: "© 2024-2025 Pozivnica.hr™. Sva prava pridržana.",
};

export const LoginStrings = {
  header: "Prijavi se",
  paragraph: "Još nemaš korisnički račun?",
  registerButton: "Registriraj se ovdje",
  googleButton: "Prijavi se s Google računom",
  or: "ILI",
  emailAddress: "Email adresa",
  emailErr: "Email adresa nije valjana",
  password: "Lozinka",
  passwordErr: "Potrebno je 8+ znakova",
  forgotPasswordButton: "Zaboravljena lozinka",
  loginButton: "Prijavi se",
  loginButtonLoading: "Prijava...",
  emailAlert: "Email adresa nije valjana.",
  passwordAlert: "Lozinka mora imati minimalno 8 znakova.",
  loginAlert: "Pogrešan email ili lozinka.",
};

export const SignupStrings = {
  header: "Registriraj se",
  paragraph: "Već imaš korisnički račun?",
  loginButton: "Prijavi se ovdje",
  googleButton: "Registriraj se s Google računom",
  or: "ILI",
  name: "Ime",
  nameErr: "Ime nije valjano",
  surname: "Prezime",
  surnameErr: "Prezime nije valjano",
  emailAddress: "Email adresa",
  emailAddressErr: "Email adresa nije valjana",
  password: "Lozinka",
  passwordErr: "Potrebno je 8+ znakova",
  confirmPassword: "Potvrdi lozinku",
  confirmPasswordErr: "Lozinke se trebaju podudarati",
  registerButton: "Registriraj se",
  registerButtonLoading: "Registracija...",
  emailAlert: "Email adresa nije valjana.",
  passwordAlert: "Lozinka mora imati minimalno 8 znakova.",
  confirmPasswordAlert: "Lozinke se ne podudaraju",
  userExistsAlert: "Korisnik već postoji.",
  serverAlert: "Nešto je pošlo po krivu, molimo pokušajte kasnije.",
  verificationEmailSentAlert:
    "Verifikacijski email je poslan na Vašu email adresu.",
};

export const ForgotPasswordStrings = {
  header: "Zaboravljena lozinka?",
  paragraph: "Sjećaš se svoje lozinke?",
  loginButton: "Prijavi se ovdje",
  emailAddress: "Email adresa",
  emailAddressErr: "Email adresa nije valjana",
  resetPasswordButton: "Resetiraj lozinku",
  resetPasswordButtonLoading: "Slanje...",
  serverAlert: "Nešto je pošlo po krivu, molimo pokušajte kasnije.",
  emailAddressAlert: "Email adresa nije valjana",
  resetPasswordEmailSentAlert: "Email za resetiranje lozinke je poslan.",
};

export const ResetPasswordStrings = {
  header: "Resetiranje lozinke",
  paragraph: "Molimo unesite novu lozinku",
  password: "Nova lozinka",
  passwordErr: "Potrebno je 8+ znakova",
  confirmPassword: "Potvrdi novu lozinku",
  confirmPasswordErr: "Lozinke se trebaju podudarati",
  resetPasswordButton: "Resetiraj lozinku",
  resetPasswordButtonLoading: "Slanje...",
  successAlert: "Lozinka je uspješno resetirana.",
  serverAlert: "Nešto je poslo po krivu, molimo pokušajte kasnije.",
  passwordAlert: "Lozinka mora imati minimalno 8 znakova.",
  confirmPasswordAlert: "Lozinke se ne podudaraju.",
};

export const TierStrings = {
  header: "Odaberi paket",
  tiers: [
    {
      id: "basic",
      name: "Basic",
      price: "0",
      features: ["Digitalna pozivnica", "Do 50 uzvanika", "Praćenje odgovora"],
    },
    {
      id: "premium",
      name: "Premium",
      price: "99",
      features: [
        "Digitalna pozivnica",
        "Neograničen broj uzvanika",
        "Praćenje odgovora",
        "Raspored sjedenja",
      ],
    },
  ],
};

export const DashboardStrings = {
  activeInvitesHeader: "Aktivne pozivnice",
  inactiveInvitesHeader: "Neaktivne pozivnice",
  testimonialHeader: "Recenzija",
  inviteCreatedAlert:
    "Vaša pozivnica je kreirana. Kako bi je podjelili potrebno je aktivirati.",
};

export const DashboardInviteCardStrings = {
  activate: "Aktiviraj",
  guests: "Uzvanici",
  edit: "Uredi",
  share: "Podijeli",
  delete: "Izbriši",
  deleteAlert:
    "Potvrdom ovog dijaloga Vaša pozivnica te uzvanici koji su odgovorili biti će izbrisani",
  shareAlert: "Link pozivnice je kopiran u međuspremnik",
};

export const TestimonialCardStrings = {
  sendTestimonial: "Slanje",
  cancelTestimonial: "Odustani",
  saveTestimonial: "Spremi",
  editTestimonial: "Uredi recenziju",
  writeTestimonial: "Napiši recenziju",
  emptyAlert: "Da bi dodali recenziju molimo Vas prvo dodajte ocjenu",
  deleteTestimonial: "Izbriši",
  deleteAlert: "Izbriši recenziju",
  deleteSuccess: "Vasa recenzija je uspjesno izbrisana",
  deleteError: "Nesto je poslo po krivu, molimo pokusajte kasnije",
};
